export { default, handle } from "/Users/julian/work/personal/wwsu-2022/app/routes/impressum.tsx";